var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMethodologyIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Universe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 35.6462882,
    height: 36,
    rx: 3.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.Index---Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-IB---Create-New-Methodology---03",
    transform: "translate(-280.000000, -110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(255.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Methodology-Icon",
    transform: "translate(25.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "M",
    fill: "#0039CB",
    fillRule: "nonzero",
    points: "4.99048035 31.68 4.99048035 5.04 12.3368049 5.04 18.1605751 25.8464234 23.9843453 5.04 31.3687336 5.04 31.3687336 31.68 27.1055816 31.68 27.1055816 9.82353285 26.5346237 9.82353285 20.3682788 30.5910657 15.9528713 30.5910657 9.7865264 9.82353285 9.21556854 9.82353285 9.21556854 31.68"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMethodologyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MethodologyIcon.a601da0c.svg";
export { ForwardRef as ReactComponent };